// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-messagebar {
  padding: 8px 16px;
}
.bolt-messagebar.severity-info {
  background-color: rgba(0, 0, 0, 0.02);
  background-color: var(--palette-black-alpha-2,rgba(0, 0, 0, 0.02));
}
.bolt-messagebar.severity-success {
  background-color: rgba(223, 246, 221, 1);
  background-color: var(--status-success-background,rgba(223, 246, 221, 1));
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-messagebar.severity-success {
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
.bolt-messagebar.severity-warning {
  background-color: rgba(251, 242, 236, 1);
  background-color: var(--status-warning-background,rgba(251, 242, 236, 1));
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-messagebar.severity-warning {
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
.bolt-messagebar.severity-error {
  background-color: rgba(249, 235, 235, 1);
  background-color: var(--status-error-background,rgba(249, 235, 235, 1));
}

.bolt-messagebar-icons,
.bolt-messagebar-buttons {
  max-height: 50px;
}

.bolt-messagebar-icon {
  margin-left: 8px;
  margin-right: 16px;
}
.severity-info .bolt-messagebar-icon {
  color: rgba(0, 120, 212, 1);
  color: var(--status-info-foreground,rgba(0, 120, 212, 1));
}
.severity-success .bolt-messagebar-icon {
  color: rgba(16, 124, 16, 1);
  color: var(--status-success-foreground,rgba(16, 124, 16, 1));
}
.severity-warning .bolt-messagebar-icon {
  color: rgba(177, 133, 37, 1);
  color: var(--status-warning-icon-foreground,rgba(177, 133, 37, 1));
}
.severity-error .bolt-messagebar-icon {
  color: rgba(205, 74, 69, 1);
  color: var(--status-error-foreground,rgba(205, 74, 69, 1));
}

.bolt-messagebar-message {
  align-items: center;
  min-height: 32px;
}
.bolt-messagebar-message:not(:last-child) {
  margin-right: 90px;
}

.bolt-messagebar-buttons {
  margin-left: auto;
}
.bolt-messagebar-buttons .bolt-button:first-child {
  margin-left: 8px;
}
.bolt-messagebar-buttons .bolt-button:not(:last-child) {
  margin-right: 8px;
}

.bolt-messagebar-close-button.bolt-button.icon-only {
  font-size: 1rem;
  padding: 0px;
  margin-right: -4px;
}

.bolt-messagebar.mobile .bolt-messagebar-content {
  padding: 10px 20px 10px 10px;
}
.bolt-messagebar.mobile .bolt-messagebar-icon {
  align-self: flex-start;
  margin: 0px;
  padding: 6px 8px;
}
.bolt-messagebar.mobile .bolt-messagebar-message {
  margin: 0px 0px 6px 8px;
  min-height: 0px;
}
.bolt-messagebar.mobile .bolt-messagebar-buttons {
  margin-bottom: 6px;
  margin-top: 2px;
}
.bolt-messagebar.mobile .bolt-messagebar-close-button {
  margin-left: 8px;
  margin-right: -10px;
}

/*# sourceMappingURL=MessageBar.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/MessageBar/MessageBar.scss","webpack://./../azure-devops-ui/bin/Components/MessageBar/MessageBar.css","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AAIA;EACI,iBAAA;ACHJ;ADKI;EACI,qCEiIU;EDpIhB,kEAAkE;ADMhE;ACJJ;EACE,wCAAwC;ECyYlC,yEAAA;ADvYR;AACA;EDQI,6BAAA;EACI,qDE2NoB;ADjO5B;ACmYQ;EF1XI,wCEkIM;EDxIhB,yEAAyE;ADUvE;ACRJ;EACE,6BAA6B;EAC7B,qDAAqD;ADWvD;AAAA;EAEI,wCAAA;ECTF,uEAAuE;AACzE;;AAEA;;EAEE,gBAAgB;ADWd;;ACRJ;EDYI,gBAAA;EACI,kBE6KoB;ADvL5B;ADaI;EACI,2BEqLyB;EDhM/B,yDAAyD;ADcvD;ACZJ;EACE,2BAA2B;EAC3B,4DAA4D;ADe9D;ACbA;EDeI,4BE4QS;EDzRX,kEAAkE;ADehE;ACbJ;EACE,2BAA2B;EAC3B,0DAA0D;ADgB5D;;ACbA;EDgBI,mBAAA;EACI,gBE8OI;AD5PZ;ADiBI;EACI,kBE0OI;ADzPZ;;ADoBA;EACI,iBE6LS;AD9Mb;AACA;EACE,gBAAgB;AAClB;ADqBI;EACI,iBAAA;ACnBR;;AAEA;EDsBQ,eAAA;EACA,YAAA;ECpBN,kBAAkB;ADuBhB;;ACpBJ;EACE,4BAA4B;ADwB1B;ACtBJ;EDwBQ,sBAAA;ECtBN,WAAW;EDyBT,gBAAA;ACvBJ;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,yCAAyC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
